


import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { BsCalendar } from 'react-icons/bs';

const CheckIn = ({ selectedDate, onChangeDate, minDate }) => {
  return (
    <div className="flex items-center space-x-2">
      <BsCalendar className="text-yellow-500 text-lg" />
      <DatePicker
        id="checkIn"
        className="bg-transparent w-full text-gray-800 text-sm font-semibold focus:outline-none"
        selected={selectedDate}
        onChange={onChangeDate}
        minDate={minDate}
        dateFormat="EEE dd MMM"
      />
    </div>
  );
};

export default CheckIn;
